import { useState, useEffect } from 'react'

import { useLogic } from '../../../Game/useLogic'
import { useDispatch, useSelector } from 'react-redux'

import { setStage } from '../../../reducers/stageReducer'
import { setWinner } from '../../../reducers/winnerReducer'

import Act from "../../../Game/Act/Act"
import Messages from './GameContainers/Messages/Messages'
import Selectors from './GameContainers/Selectors/Selectors'
import InterludeAnimation from '../../InterludeAnimation/InterludeAnimation'

import './TheGame.css'
import { useSelectors } from './GameContainers/Selectors/useSelectors'
import { useAudios } from '../../../assets/useAudios'

const TheGame = () => {
    const [nextMessage, setNextMessage] = useState({})

    const [showInterludeAnimation, setShowInterludeAnimation] = useState(false)
    const [interludeMessage, setInterludeMessage] = useState('')
    const [purgeMessageList, setPurgeMessageList] = useState(false)

    const [selectorOptions, setSelectorOptions] = useState([])
    const [selectorsOpen, setSelectorsOpen] = useState(false)
    const [gameEnds, setGameEnds] = useState(null)
    const [showSelectors, setShowSelectors] = useState(true)

    const role = useSelector(state => state.role)
    const dispatch = useDispatch()

    const gameLogic = useLogic()
    const selectorTools = useSelectors()
    const audio = useAudios()

    const [act, setAct] = useState(1)
    const [set, setSet] = useState(1)

    useEffect(() => {       
        const playActZero = async () => {

            const buyerOptions = ["B0_1","B0_2","B0_3","B0_4","B0_5","B0_6"]
            const firstBuyer = gameLogic.randomResponse(buyerOptions)
            setNextMessage({
                speaker: 'customer',
                message: firstBuyer.line
            })
            await audio.setAndPlay(firstBuyer.code)

            if (role !== 'seller') {
                const sellerOptions = ["A1_1","A1_2","A1_3"]
                const firstSeller = gameLogic.randomResponse(sellerOptions)
                setNextMessage({
                    speaker: 'seller',
                    message: firstSeller.line
                })
                await audio.setAndPlay(firstSeller.code)
            }

            const currentSet = gameLogic.getSet(act, set)
            await fireAnimation(role === 'seller' ? 'Matsi alkakoon!' : 'Kamppailu käyntiin!')
            installNewSelectorOptions(currentSet.playerOptions)
        } 
        
        playActZero() 
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (gameEnds) {
            dispatch(setWinner(gameEnds))
        }
        // eslint-disable-next-line
    }, [gameEnds])


    const calcNextMessage = async (playerSelection) => {
        let currentSet = gameLogic.getSet(act, set)

        if (playerSelection && act === 2 && set === 3 && role === 'seller') {
            //Custom solution for final round
            playFinalRound(playerSelection, currentSet)
            return
        }

        if (playerSelection && role === 'customer' && set === 4) {
            playFinalRoundOfCustomer(playerSelection, currentSet)
            return
        }

        if (!currentSet) {
            currentSet = gameLogic.getSet(act + 1, 1)
            setAct(act + 1)
            setSet(1)
        }

        if (playerSelection) {
            const playerLine = gameLogic.randomResponse(playerSelection.response)
            setNextMessage({
                speaker: role,
                message: playerLine.line
            })
            await audio.setAndPlay(playerLine.code)

            let nextSet = gameLogic.getSet(act, set + 1)
            let updateAct = false
            if (!nextSet) {
                updateAct = true
                nextSet = gameLogic.getSet(act + 1, 1)
            }

            const opponentResponseItem = gameLogic.getOpponentResponse(currentSet.opponentOptions)

            setNextMessage({
                speaker: opponentResponseItem.speaker,
                message: opponentResponseItem.text
            })
            if (opponentResponseItem.code.code) {
                await audio.setAndPlay(opponentResponseItem.code.code)
            } else {
                await audio.setAndPlay(opponentResponseItem.code)
            }

            if (opponentResponseItem.code.winner) {
                endDiscussion(currentSet, opponentResponseItem.code.winner)
            } else {
                if (updateAct) {
                    setAct(act + 1)
                    setSet(1)
                } else {
                    setSet(set + 1)
                }
            }

            if (currentSet.animationMessage) {
                await fireAnimation(currentSet.animationMessage)
            }

            if (nextSet) {
                installNewSelectorOptions(nextSet.playerOptions)
            }
            return
        }
    }


    const endDiscussPlayer = async (options, winner) => {
        const response = gameLogic.randomResponse(options[0])
        setNextMessage({
            speaker: response.code[0] === 'A' ? 'seller' : 'buyer',
            message: response.line
        })
        await audio.setAndPlay(response.code)
        const secondResponse = gameLogic.randomResponse(options[1])
        setNextMessage({
            speaker: secondResponse.code[0] === 'A' ? 'seller' : 'buyer',
            message: secondResponse.line
        })
        await audio.setAndPlay(secondResponse.code)
        setGameEnds(winner)
    }

    const endDiscussion = async (currentSet, winner) => {
        setShowSelectors(false)
        if (currentSet.hasEndDiscussion) {
            if (winner === 'player') {
                endDiscussPlayer(currentSet.playerWinsDiscussion, winner)
            } else {
                endDiscussPlayer(currentSet.opponentWinsDiscussion, winner)
            }
            return
        }

        setGameEnds(winner)
    }

    const playFinalRound = async (playerSelection, set) => {
        const playerLine = gameLogic.randomResponse(playerSelection.response)
        setNextMessage({
            speaker: role,
            message: playerLine.line
        })
        await audio.setAndPlay(playerLine.code.code)


        const whoIsWinner = playerSelection.response.find(response => response.code === playerLine.code.code).winner
        endDiscussion(set, whoIsWinner)
    }

    const playFinalRoundOfCustomer = async (playerSelection, set) => {
        const playerLine = gameLogic.randomResponse(playerSelection.response)
        setNextMessage({
            speaker: role,
            message: playerLine.line
        })
        await audio.setAndPlay(playerLine.code.code)

        const hasWinner = playerSelection.response.find(response => response.code === playerLine.code.code).winner
        
        if (hasWinner) {
            endDiscussion(set, hasWinner)
            return
        }

        const currentSet = gameLogic.getSet(act, set.setNo) 
        const opponentResponseItem = gameLogic.getOpponentResponse(currentSet.opponentOptions)

        setNextMessage({
            speaker: 'seller',
            message: opponentResponseItem.text
        })
        await audio.setAndPlay(opponentResponseItem.code.code)
        endDiscussion(currentSet, opponentResponseItem.code.winner)
    }

    const installNewSelectorOptions = (options) => {
        const newSelectors = gameLogic.getPlayerOptions(options)
        const formattedSelectors = selectorTools.formatSelectors(newSelectors)
        setSelectorOptions(formattedSelectors)
        setSelectorsOpen(true)

        if (newSelectors && newSelectors.length > 0 && newSelectors[0].hint) {
            dispatch(setStage(newSelectors[0].hint[1]))
        }
    }

    const fireAnimation = (message) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                setInterludeMessage(message)
                setShowInterludeAnimation(true)
                setPurgeMessageList(true)
            }, 300)

            setTimeout(() => {
                setShowInterludeAnimation(false)
                resolve()
            }, 2500)
        })
    }

    if (showInterludeAnimation) {
        return (
            <InterludeAnimation
                message={interludeMessage}
                showInterludeAnimation={showInterludeAnimation}
                setShowInterludeAnimation={setShowInterludeAnimation} />
        )
    }

    return (
        <>
            <Act />
            <div className='flex game-container' id='game-container-id'>
                <Messages nextMessage={nextMessage} clearMessages={purgeMessageList} />
                {showSelectors && <Selectors
                    open={selectorsOpen}
                    setOpen={setSelectorsOpen}
                    calcNextMessage={calcNextMessage}
                    newSelectors={selectorOptions} />}
            </div>
        </>
    )
}

export default TheGame